import {
  FILTER_PROCESS_GROUP,
  PAGE_VIEW_KEY,
  PAGE_VIEW_VALUES,
  URL_DEFINED_PROCESSES
} from '../../../constants'
import { getUpdatedUrl } from '../../../utils/urlUtil'

export const getFormattedProcessesData = (
  processes,
  totalProcesses,
  baseUrl,
  intl,
  colorMapper,
  urlFilter = {}
) => {
  const sortedGroups = [...processes].sort((a, b) => b.count - a.count)
  const topGroups = sortedGroups.slice(0, 4)
  const remainingGroups = sortedGroups.slice(4)
  const assignedTotal = sortedGroups.reduce((sum, group) => sum + group.count, 0)

  const list = topGroups.map((item, index) => ({
    key: item.name,
    value: item.count,
    color: colorMapper[index],
    link: getUpdatedUrl({
      pathName: `${baseUrl}${URL_DEFINED_PROCESSES}`,
      pageName: URL_DEFINED_PROCESSES,
      pageQueryParams: {
        [FILTER_PROCESS_GROUP]: item.id,
        [PAGE_VIEW_KEY]: PAGE_VIEW_VALUES.list,
        ...urlFilter
      }
    })
  }))

  if (sortedGroups.length > 4) {
    list.push({
      key: intl.formatMessage({ id: 'ropa.report.others' }),
      value: remainingGroups.reduce((sum, curr) => sum + curr.count, 0),
      color: colorMapper[4],
      link: getUpdatedUrl({
        pathName: `${baseUrl}${URL_DEFINED_PROCESSES}`,
        pageName: URL_DEFINED_PROCESSES,
        pageQueryParams: {
          [FILTER_PROCESS_GROUP]: remainingGroups.map((item) => item.id).join(','),
          [PAGE_VIEW_KEY]: PAGE_VIEW_VALUES.list,
          ...urlFilter
        }
      })
    })
  }

  if (totalProcesses > assignedTotal)
    list.push({
      key: intl.formatMessage({ id: 'consentManagement.unknown' }),
      value: totalProcesses - assignedTotal,
      color: colorMapper[5],
      link: '#'
    })

  return list
}

export const checkIfAllEmpty = (data) => (data.some((item) => item.value > 0) ? data : [])
